import React from 'react';
import Container from '../layout/Container';
import Eyebrow from '../ui/Eyebrow';
import SectionHeading from '../ui/SectionHeading';
import { teamMembers } from '../../data/team';
import { colors } from '../../lib/tokens';

export default function TeamStripSection() {
  return (
    <section
      id="team"
      className="kc-section"
      style={{
        background: colors.bg,
        borderTop: `1px solid ${colors.hair}`,
      }}
    >
      <Container>
        <div data-reveal>
          <Eyebrow>Team</Eyebrow>
          <SectionHeading style={{ marginBottom: 56 }}>
            Clinicians and engineers,
            {' '}<br />
            working side by side.
          </SectionHeading>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-x-5 gap-y-10 md:gap-8">
          {teamMembers.map((m, i) => (
            <div key={m.name} data-reveal style={{ '--d': `${i * 70}ms` } as React.CSSProperties}>
              {/* Framed so the photo revealed on hover fades in inside a
                  defined edge rather than appearing as a bare rectangle. */}
              <div
                className="team-portrait"
                tabIndex={0}
                aria-label={`${m.name}, portrait. Focus or hover to reveal photo.`}
                style={{
                  aspectRatio: '4 / 5',
                  borderRadius: 10,
                  border: `1px solid ${colors.hair}`,
                  background: colors.surface,
                  overflow: 'hidden',
                  marginBottom: 16,
                  position: 'relative',
                  cursor: 'pointer',
                }}
              >
                <img
                  src={m.image}
                  alt={m.name}
                  loading="lazy"
                  decoding="async"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    position: 'absolute',
                    inset: 0,
                  }}
                />
                <img
                  src={m.photo}
                  alt=""
                  aria-hidden
                  className="team-portrait-photo"
                  loading="lazy"
                  decoding="async"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    position: 'absolute',
                    inset: 0,
                    filter: 'grayscale(1) contrast(1.02)',
                  }}
                />
              </div>
              <div style={{ fontSize: 15, fontWeight: 500, color: colors.ink }}>{m.name}</div>
              <div style={{ fontSize: 13, color: colors.ink2, marginTop: 4 }}>{m.title}</div>
              <div style={{ fontSize: 12, color: colors.muted, marginTop: 6, lineHeight: 1.5 }}>
                {m.credentials}
              </div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
}
